/* eslint-disable */
import axios from 'axios';
import config from '@assets/config.json'; // api 请求json  

// 通用 Module 
const state = {
  invoiceAlter: false, // 发票修改信息是否显示
}
const mutations = {
  setInvoiceAlter (state, data) {
    state.invoiceAlter = data;
  },
}
const getters = {
  getInvoiceAlter: state => {
    return state.invoiceAlter;
  },
}
const actions = {
  // 获取企业性质
  getNature ({ rootState }) {
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/Nature/GetList`, rootState.header).then(data => {
        if (data.data) { resolve(data.data); }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getNatureById ({ rootState }, id) { // id获取企业性质
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/Nature?id=${id}`, rootState.header).then(data => {
        if (data.data) { resolve(data.data); }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  delNature ({ rootState }, id) { // 删除企业性质
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/Nature?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  editNature ({ rootState }, opt) { // 修改企业性质
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/Nature`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  addNature ({ rootState }, opt) { // 添加企业性质
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/Nature`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },


  // 获取企业经营类别
  getBusinessType ({ rootState }) {
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/BusinessType/GetList`, rootState.header).then(data => {
        if (data.data) { resolve(data.data); }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getBusinessTypeById ({ rootState }, id) { // id获取企业经营类别
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/BusinessType?id=${id}`, rootState.header).then(data => {
        if (data.data) { resolve(data.data); }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  delBusinessType ({ rootState }, id) { // 删除企业经营类别
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/BusinessType?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  editBusinessType ({ rootState }, opt) { // 修改企业经营类别
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/BusinessType`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  addBusinessType ({ rootState }, opt) { // 添加企业经营类别
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/BusinessType`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },


  // 获取产品标签
  getProTag ({ rootState }) {
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/ProTag/GetListAndChildren`, rootState.header).then(data => {
        if (data.data) { resolve(data.data); }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getProTagById ({ rootState }, id) { // id获取产品标签
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/ProTag?id=${id}`, rootState.header).then(data => {
        if (data.data) { resolve(data.data); }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  delProTag ({ rootState }, id) { // 删除产品标签
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/ProTag?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  editProTag ({ rootState }, opt) { // 修改产品标签
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/ProTag`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  addProTag ({ rootState }, opt) { // 添加产品标签
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/ProTag`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  // 获取产品认证
  getProAuth ({ rootState }) {
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/ProAuth/GetList`, rootState.header).then(data => {
        if (data.data) { resolve(data.data); }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  // 获取质量体系认证
  getProQualities ({ rootState }) {
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/ProCertificateQualities/GetList`, rootState.header).then(data => {
        if (data.data) { resolve(data.data); }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getProAuthById ({ rootState }, id) { // id获取产品认证
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/ProAuth?id=${id}`, rootState.header).then(data => {
        if (data.data) { resolve(data.data); }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  delProAuth ({ rootState }, id) { // 删除产品认证
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/ProAuth?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  editProAuth ({ rootState }, opt) { // 修改产品认证
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/ProAuth`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  addProAuth ({ rootState }, opt) { // 添加产品认证
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/ProAuth`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
} 